require('../components/ga-events');
const CustomSelect = require('./custom-select');
const LanguageAndCurrencySelectors = require('./language-and-currency-selectors');
const JsLinks = require('./js-links');
const Annotations = require('./annotations');
const ScrollToTop = require('./scroll-to-top');
const ExitPopup = require('./exit-popup');
const MainSearch = require('./main-search');
const MobileMenu = require('./mobile-menu');
const $ = require('cash-dom');
const DynamicData = require('../components/dynamic-data');
const Tooltip = require('../components/tooltips');
const ShareButtons = require('../components/share-buttons');
const Video = require('../components/video');
require('../components/keyboard-navigation');

const Base = {
  init() {
    const self = this;

    DynamicData.init();
    CustomSelect.init();
    LanguageAndCurrencySelectors.init();
    JsLinks.init();
    Annotations.init();
    ScrollToTop.init();
    ExitPopup.init();
    MainSearch.init();
    MobileMenu.init();
    Tooltip.init();
    ShareButtons.init();
    Video.init();

    $('.adsbygoogle').each(function () {
      (adsbygoogle = window.adsbygoogle || []).push({});
    });

    if(document.body.textContent.includes('/go/')){
      $('.top-disclosure').show();
    }

    //dropdown-box shortcode
    $(document).on('mousedown', '.article-dropdown-box-container .dropdown-box-title', (e) => {
      e.preventDefault();

      $(e.target).closest('.article-dropdown-box-container').toggleClass('active');
    });
  },
};

module.exports = Base;
